import * as React from "react";
import {
  Navigate,
  Outlet,
  createRootRoute,
  useRouterState,
} from "@tanstack/react-router";
import { LoginComponent } from "../components/LoginComponent";
import { useLoginStatus } from "../hooks/useLoginStatus";
import { useEffect } from "react";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/app/reeprise" replace />,
});

function RootComponent() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const loginStatus = useLoginStatus();

  if (!loginStatus.isSuccess) {
    return <></>;
  }

  if (loginStatus.data.state === "logged out" && pathname !== "/secretsignup") {
    return <LoginComponent />;
  }

  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
